module.exports = __webpack_public_path__ + "static/img/bottom3.103fe5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bottom3.png
// module id = x80G
// module chunks = 25